<template>
  <div class="products" style="padding: 0">
    <div
      class="food-info-text"
      :style="{ 'border-radius': isHomeVersionPremium ? '20px' : '0px' }"
    >
      <ul class="allergens-legend">
        <li>
          <span
            ><i class="allergene-icon vegetarian" />&nbsp;{{
              $t("products.vegetarian")
            }}</span
          >
        </li>
        <li class="">
          {{ $t("products.allergens") }}
        </li>
        <li class="">
          <span
            ><i class="allergene-icon lupin" />&nbsp;{{
              $t("products.lupins")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon celery" />&nbsp;{{
              $t("products.celery")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon peanuts" />&nbsp;{{
              $t("products.peanuts")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon crustacean" />&nbsp;{{
              $t("products.crustaceans")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon gluten" />&nbsp;{{
              $t("products.gluten")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon egg" />&nbsp;{{
              $t("products.egg")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon milk" />&nbsp;{{
              $t("products.dairyProducts")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon mustard" />&nbsp;{{
              $t("products.mustard")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon fish" />&nbsp;{{
              $t("products.fish")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon sesame" />&nbsp;{{
              $t("products.sesame")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon soy" />&nbsp;{{
              $t("products.soy")
            }}</span
          >
        </li>
        <li class="">
          <span
            ><i class="allergene-icon sulfite" />&nbsp;{{
              $t("products.sulfite")
            }}</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllergensLegend"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
